import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["onClick", "onFocus", "onMouseenter", "onBlur", "onMouseleave"]
const _hoisted_2 = { class: "hc-legend-text" }

import { LegendItem, LegendStyle } from "@/guiide/ts/response/charts/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChartLegend',
  props: {
    items: {},
    disable: { type: Boolean, default: false }
  },
  emits: ["item-toggle", "item-focus", "item-blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function onClick(item: LegendItem) {
  emit('item-toggle', item);
}

function symbolClass(item: LegendItem) {
  return item.style === LegendStyle.Line
    ? "hc-legend-symbol--line"
    : "hc-legend-symbol--circle";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hc-legend", { 'hc-legend--inactive': _ctx.disable }]),
    role: "group",
    "aria-label": "Chart legend"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("button", {
        key: item.key,
        type: "button",
        class: _normalizeClass(["hc-legend-item", { 'hc-legend-item--inactive': !item.visible }]),
        onClick: ($event: any) => (onClick(item)),
        onFocus: ($event: any) => (_ctx.$emit('item-focus', item)),
        onMouseenter: ($event: any) => (_ctx.$emit('item-focus', item)),
        onBlur: ($event: any) => (_ctx.$emit('item-blur', item)),
        onMouseleave: ($event: any) => (_ctx.$emit('item-blur', item))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["hc-legend-symbol", symbolClass(item)]),
          style: _normalizeStyle({ backgroundColor: item.color })
        }, null, 6),
        _createElementVNode("span", _hoisted_2, _toDisplayString(item.name), 1)
      ], 42, _hoisted_1))
    }), 128))
  ], 2))
}
}

})